export type LottieVariant = "dark" | "light";

const LOTTIE_PATHS: Record<LottieVariant, string> = {
  dark: "/replyn-hero-dark-4s.json",
  light: "/replyn-hero-light-4s.json",
};

const promiseCache = new Map<LottieVariant, Promise<unknown>>();
const dataCache = new Map<LottieVariant, unknown>();
const frameCache = new Map<LottieVariant, number>();

export const getCachedLottieData = (variant: LottieVariant): unknown | null => {
  return dataCache.get(variant) ?? null;
};

export const getCachedLottieFrame = (variant: LottieVariant): number => {
  return frameCache.get(variant) ?? 0;
};

export const setCachedLottieFrame = (
  variant: LottieVariant,
  frame: number,
): void => {
  frameCache.set(variant, frame);
};

export const getLottieData = (variant: LottieVariant): Promise<unknown> => {
  const cached = promiseCache.get(variant);

  if (cached) return cached;

  const promise = fetch(LOTTIE_PATHS[variant])
    .then((res) => {
      if (!res.ok)
        throw new Error(
          `Failed to load ${LOTTIE_PATHS[variant]}: ${res.status}`,
        );

      return res.json();
    })
    .then((data) => {
      dataCache.set(variant, data);

      return data;
    });

  promiseCache.set(variant, promise);

  return promise;
};
